<template>
  <div class="creative-group-wrap">
    <div class="card-header">
      创意组<span class="num-text">{{ dataList.length }}/50</span>
      <span class="nodata-tip" v-if="showNoDataTip">请完善创意组数据</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" :disabled="!adCount" @click="newCreative"
          >新增</el-button
        ><span class="center-line"></span>

        <!-- <el-dropdown @command="(key) => showMaterialModal(true, key)">
          <el-button icon="el-icon-plus" type="text">批量新增</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="video" :disabled="!adCount || isUnionSplash">批量添加视频素材</el-dropdown-item>
            <el-dropdown-item command="image" :disabled="!adCount">批量添加图片素材</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <!-- <span class="center-line"></span>
         -->
        <el-button icon="el-icon-plus" type="text" :disabled="!adCount" @click="selectGroup"
          >选择已有</el-button
        >

        <span class="center-line"></span>
        <el-button @click="clearAllGroup" type="text" :disabled="!adCount">清空</el-button>
      </div>
    </div>
    <div v-show="adCount && dataList.length > 0">
      <div class="card-list">
        <card-item
          v-for="(item, index) of dataList"
          :key="item.itemId"
          :title="'新建创意组' + (index + 1)"
          :dataSet="item"
          @edit="editCreativeGroup"
          @copy="copyCreativeGroup"
          @del="delCreativeGroup"
          :isCur="curItem.itemId === item.itemId"
          :showDelete="true"
        ></card-item>
      </div>
      <div class="modal-body" v-loading="loading">
        <ul class="modal-form">
          <el-form ref="modelRef" :model="formData" :rules="rules">
            <li class="form-item" style="margin-bottom: 0px">
              <span class="form-label" style="padding-top: 10px">创意组名称：</span>
              <div class="form-value">
                <el-form-item prop="groupName">
                  <el-input
                    v-model="formData.groupName"
                    placeholder="请填写"
                    style="width: 225px"
                    @input="changeGroupName"
                  ></el-input>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 4px">投放场景：</span>
              <div class="form-value">
                <div class="upload-header">
                  <el-form-item prop="curMaterialType">
                    <el-radio-group v-model="formData.curMaterialType">
                      <el-radio label="video" :disabled="isUnionSplash"
                        >视频({{ videoList.length }}/20)</el-radio
                      >
                      <el-radio label="image">图片({{ imageList.length }}/20)</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-button
                    class="add-btn"
                    type="text"
                    icon="el-icon-plus"
                    @click="showMaterialModal(false)"
                    :disabled="
                      (formData.curMaterialType === 'video' && videoList.length >= 20) ||
                      (formData.curMaterialType === 'image' && imageList.length >= 20)
                    "
                    >添加素材</el-button
                  >
                </div>
                <div class="upload-wrap">
                  <div
                    class="content-wrap video-wrap"
                    v-show="formData.curMaterialType === 'video'"
                  >
                    <div class="video-item" v-for="item of videoList" :key="item.uuid">
                      <div class="video-slide">
                        <div class="video-header">视频:</div>
                        <div class="video-content">
                          <video controls="controls" class="material" :src="item.path"></video>
                        </div>
                      </div>
                      <div class="video-slide">
                        <div class="video-header">封面:</div>
                        <div class="video-content">
                          <img class="material" :src="item.coverPath" />
                        </div>
                      </div>
                      <span class="close-btn" @click="deleteMaterial(item.uuid)"
                        ><i class="el-icon-close"></i
                      ></span>
                    </div>
                  </div>
                  <div
                    class="content-wrap image-wrap"
                    v-show="formData.curMaterialType === 'image'"
                  >
                    <div class="img-item" v-for="item of imageList" :key="item.uuid">
                      <img class="img" :src="item.path" />
                      <span class="close-btn" @click="deleteMaterial(item.uuid)"
                        ><i class="el-icon-close"></i
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require">标题({{ formData.titles.length }}/5)：</span>
              <el-form-item prop="titles">
                <div style="display: flex; width: 400px">
                  <el-button
                    type="text"
                    @click="newAddItem('title')"
                    :disabled="formData.titles.length > 4"
                    >新增标题</el-button
                  ><span class="label-line"></span>
                  <el-button type="text" @click="selectHasItem('title')">选择已有</el-button
                  ><span class="label-line"></span>
                  <el-button type="text" @click="batchAddItem('title')">批量添加</el-button>
                  <el-button
                    style="flex: 1; text-align: end"
                    type="text"
                    @click="saveItemPkg('title')"
                    >保存为标题包</el-button
                  >
                </div>
                <div v-for="(item, index) in formData.titles" :key="index">
                  <el-input
                    maxlength="30"
                    show-word-limit
                    style="width: 400px"
                    placeholder="请输入标题"
                    v-model.trim="formData.titles[index]"
                  >
                  </el-input>
                  <i
                    class="el-icon-delete"
                    @click="deleteItem('title', index)"
                    v-if="formData.titles.length > 2"
                    style="margin-left: 12px; color: red; cursor: pointer"
                  ></i>
                </div>
              </el-form-item>
            </li>
            <li class="form-item">
              <span class="form-label require">描述({{ formData.descriptions.length }}/5)：</span>
              <el-form-item prop="descriptions">
                <div style="display: flex; width: 400px">
                  <el-button
                    type="text"
                    @click="newAddItem('describe')"
                    :disabled="formData.descriptions.length > 4"
                    >新增描述</el-button
                  ><span class="label-line"></span>
                  <el-button type="text" @click="selectHasItem('describe')">选择已有</el-button
                  ><span class="label-line"></span>
                  <el-button type="text" @click="batchAddItem('describe')">批量添加</el-button>
                  <el-button
                    style="flex: 1; text-align: end"
                    type="text"
                    @click="saveItemPkg('describe')"
                    >保存为描述包</el-button
                  >
                </div>
                <div v-for="(item, index) in formData.descriptions" :key="index">
                  <el-input
                    maxlength="90"
                    show-word-limit
                    style="width: 400px"
                    placeholder="请输入描述"
                    v-model.trim="formData.descriptions[index]"
                  >
                  </el-input>
                  <i
                    class="el-icon-delete"
                    @click="deleteItem('describe', index)"
                    v-if="formData.descriptions.length > 1"
                    style="margin-left: 12px; color: red; cursor: pointer"
                  ></i>
                </div>
              </el-form-item>
            </li>
          </el-form>
        </ul>
        <span slot="footer" class="footer-wrap">
          <el-button @click="saveCreativeGroup" type="primary">保存到创意组</el-button>
          <!-- <el-button type="primary" @click="confirmSelect">确 定</el-button> -->
        </span>
      </div>
    </div>
    <div v-show="!adCount || dataList.length === 0" class="select-count">
      {{ dataList.length === 0 ? "暂无数据" : "请选择账户" }}
    </div>

    <!-- 素材选择弹框 -->
    <material-modal
      ref="materialModalRef"
      @selectOk="selectedMaterial"
      :selectType="formData.curMaterialType"
      :showGroupNum="showGroupNum"
      :isUnionSplash="isUnionSplash"
    ></material-modal>

    <!-- 选择已有创意组 -->
    <checked-modal
      :title="checkedModalObj.checkedModalTitle"
      :tableConf="checkedModalObj.tableConf"
      ref="checkedModalRef"
      @selectOk="selectOk"
    ></checked-modal>
    <!-- 批量添加 -->
    <muladd-modal ref="muladdModalRef" @selectOk="batchImport"></muladd-modal>
    <!-- 保存为标题包/描述包 -->
    <save-pkg-modal ref="savePkgModalRef" @confirm="confirmSavePkg"></save-pkg-modal>
  </div>
</template>

<script>
import MaterialModal from "./components/materialModal.vue";
import CheckedModal from "./components/checkedModal.vue";
import { saveAssetGroup } from "@/api/promotion-google.js";
import { mapState } from "vuex";
import CardItem from "./components/cardItem.vue";
import MuladdModal from "./components/muladdModal.vue";
import SavePkgModal from "./components/savePkgModal.vue";
export default {
  components: {
    MaterialModal,
    CardItem,
    CheckedModal,
    MuladdModal,
    SavePkgModal,
  },
  data() {
    return {
      checkedModalObj: {
        checkedModalTitle: "",
        checkedModalType: "",
        tableConf: [],
        tableData: [],
      },
      dataList: [],
      curItem: {}, //当前编辑对象
      formData: {
        groupName: "",
        curMaterialType: "video",
        titles: ["", ""],
        descriptions: [""],
      },
      videoList: [],
      imageList: [],
      loading: false,
      rules: {
        groupName: [{ required: true, message: "创意组名称必填", trigger: "blur" }],
        curMaterialType: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.videoList.length + this.imageList.length === 0) {
                callback(new Error("请上传视频或图片素材"));
              } else {
                callback();
              }
            },
          },
        ],
        titles: [
          {
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              const { flag, errorMsg } = this.validateTitles(value);
              flag.includes(true) ? callback(new Error(errorMsg)) : callback();
            },
          },
        ],
        descriptions: [
          {
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              const { flag, errorMsg } = this.validateDesc(value);
              flag.includes(true) ? callback(new Error(errorMsg)) : callback();
            },
          },
        ],
      },
      showGroupNum: false, //是否批量添加创意组
      showNoDataTip: false,
      //穿山甲开屏时查询素材新增字段 imageType=SPLASH
      isUnionSplash: false,
    };
  },
  mounted() {
    this.newCreative();
  },
  methods: {
    newCreative() {
      if (this.dataList.length >= 50) {
        return;
      }
      this.curItem.groupName = this.formData.groupName;
      let newItem = {
        itemId: Math.random(),
        groupName: "新建创意组" + (this.dataList.length + 1),
        creatives: [],
        videos: [],
        images: [],
        titles: ["", ""],
        descriptions: [""],
      };
      this.dataList.push(newItem);
      this.showEditModal(newItem);
      this.saveInStore();
    },
    editCreativeGroup(dataItem) {
      this.curItem.groupName = this.formData.groupName; //切换时保存当前的
      this.showEditModal(dataItem);
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    copyCreativeGroup(dataItem) {
      if (this.dataList.length >= 50) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(dataItem));
      this.dataList.push({
        itemId: Math.random(),
        groupName: copyData.groupName + "_复制",
        images: copyData.images,
        videos: copyData.videos,
        titles: copyData.titles,
        descriptions: copyData.descriptions,
      });
      this.saveInStore();
    },
    delCreativeGroup(dataItem) {
      let delIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(delIndex, 1);
      this.saveInStore();
    },
    clearAllGroup() {
      this.dataList = [];
      this.saveInStore();
    },
    // 新增标题
    newAddItem(type) {
      if (type === "title") {
        this.formData.titles.push("");
      } else {
        this.formData.descriptions.push("");
      }
    },
    // 选择已有
    selectHasItem(type) {
      const isTitle = type === "title";
      this.checkedModalObj = {
        tableConf: [
          { title: isTitle ? "标题包名称" : "描述包名称", colName: "groupName" },
          { title: isTitle ? "标题数量" : "描述数量", colName: "assetCount" },
          { title: "创建时间", colName: "createTime", width: "180px" },
          { title: "创建人", colName: "creator" },
        ],
        checkedModalTitle: isTitle ? "选择标题包" : "选择描述包",
        checkedModalType: type,
      };
      this.$refs.checkedModalRef.showModal(isTitle ? 3 : 4);
    },
    // 批量添加标题
    batchAddItem(type) {
      this.$refs.muladdModalRef.showModal(type);
    },
    batchImport(arr, type) {
      if (type === "title") {
        this.formData.titles = this.formData.titles.filter(Boolean);
        arr.forEach((item) => {
          if (this.formData.titles.length < 5) {
            this.formData.titles.push(item);
          }
        });
        this.curItem.titles = this.formData.titles;
      } else {
        this.formData.descriptions = this.formData.descriptions.filter(Boolean);
        arr.forEach((item) => {
          if (this.formData.descriptions.length < 5) {
            this.formData.descriptions.push(item);
          }
        });
        this.curItem.descriptions = this.formData.descriptions;
      }
    },
    // 保存为标题包
    saveItemPkg(type) {
      this.$refs.modelRef.validateField(type === "title" ? "titles" : "descriptions", (valid) => {
        if (!valid) {
          this.$refs.savePkgModalRef.showModal(type);
        }
      });
    },
    confirmSavePkg(title, type) {
      saveAssetGroup({
        advertiserId: this.adCount,
        assetType: type === "title" ? 3 : 4,
        data: JSON.stringify(type === "title" ? this.formData.titles : this.formData.descriptions),
        groupName: title,
        platType: 5,
      }).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.$message({
            message: `${type === "title" ? "标题包" : "描述包"}保存成功`,
            type: "success",
          });
        }
      });
    },
    // 删除标题包
    deleteItem(type, index) {
      if (type === "title") {
        this.formData.titles.splice(index, 1);
      } else {
        this.formData.descriptions.splice(index, 1);
      }
      this.$nextTick(() => {
        this.$refs.modelRef.validateField(type === "title" ? "titles" : "descriptions");
      });
    },
    //选择已有创意组
    selectGroup() {
      this.checkedModalObj = {
        tableConf: [
          { title: "创意组名称", colName: "groupName" },
          { title: "创建时间", colName: "createTime" },
        ],
        checkedModalTitle: "选择创意组",
        checkedModalType: "group",
      };
      this.$refs.checkedModalRef.showModal(2);
    },
    selectOk(dataList) {
      if (this.checkedModalObj.checkedModalType === "title") {
        if (this.formData.titles.length > 4) {
          this.$message.warning("标题最多为5个");
          return;
        }
        this.formData.titles = this.formData.titles.filter(Boolean);
        dataList.forEach((item) => {
          JSON.parse(item.data).map((child) => {
            if (this.formData.titles.length < 5) {
              this.formData.titles.push(child);
            }
          });
        });
        this.curItem.titles = this.formData.titles;
      } else if (this.checkedModalObj.checkedModalType === "describe") {
        if (this.formData.descriptions.length > 4) {
          this.$message.warning("描述最多为5个");
          return;
        }
        this.formData.descriptions = this.formData.descriptions.filter(Boolean);
        dataList.forEach((item) => {
          JSON.parse(item.data).map((child) => {
            if (this.formData.descriptions.length < 5) {
              this.formData.descriptions.push(child);
            }
          });
        });
        this.curItem.descriptions = this.formData.descriptions;
      } else {
        dataList.forEach((item) => {
          let groupItem = JSON.parse(item.data);
          this.dataList.push({
            itemId: Math.random(),
            groupName: groupItem.groupName,
            images: groupItem.images,
            videos: groupItem.videos,
            titles: groupItem.titles,
            descriptions: groupItem.descriptions,
          });
        });
        this.saveInStore();
      }
    },
    /**
     * flag: 素材组件内部是否展示分组信息
     * type: 素材组件展示的素材类型
     */
    showMaterialModal(flag, type) {
      this.showGroupNum = flag;
      type && (this.formData.curMaterialType = type);
      this.$nextTick(() => {
        this.$refs.materialModalRef.showModal();
      });
    },
    selectedMaterial(resData) {
      let { mapList, groupNum } = resData;
      if (groupNum) {
        this.fillAndSaveGroupData(mapList, groupNum);
      } else {
        this.fillAndSaveCurData(mapList);
      }
    },
    fillAndSaveCurData(dataList) {
      if (this.formData.curMaterialType === "video") {
        for (let dataItem of Object.values(dataList)) {
          if (!this.videoList.map((item) => item.uuid).includes(dataItem.uuid)) {
            if (this.videoList.length < 20) {
              this.videoList.push({
                uuid: dataItem.uuid,
                path: dataItem.path || dataItem.videoUrl,
                coverPath: dataItem.coverPath || dataItem.thumbnailUrl,
                fileId: dataItem.id,
                videoId: dataItem.videoId,
                name: dataItem.name,
              });
            } else {
              this.$message({
                message: "视频数量超出限制",
                type: "warning",
              });
              break;
            }
          }
        }
      } else {
        for (let dataItem of Object.values(dataList)) {
          if (!this.imageList.map((item) => item.uuid).includes(dataItem.uuid)) {
            if (this.imageList.length < 20) {
              this.imageList.push({
                uuid: dataItem.uuid,
                path: dataItem.path,
                fileId: dataItem.id,
                name: dataItem.name,
              });
            } else {
              this.$message({
                message: "图片数量超出限制",
                type: "warning",
              });
              break;
            }
          }
        }
      }
      this.confirmSelect(); //选择完成后就进行保存
    },
    deleteMaterial(uuid) {
      if (this.formData.curMaterialType === "video") {
        let delIndex = this.videoList.findIndex((item) => item.uuid === uuid);
        this.videoList.splice(delIndex, 1);
      } else {
        let delIndex = this.imageList.findIndex((item) => item.uuid === uuid);
        this.imageList.splice(delIndex, 1);
      }
      this.confirmSelect(); //删除完成后进行保存
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    //分组时不是格式化的当前list, 而是格式化外部传来的数据
    formatData() {
      return new Promise((resolve) => {
        const saveData = {
          groupName: this.formData.groupName,
          images: this.imageList,
          videos: this.videoList,
          titles: this.formData.titles,
          descriptions: this.formData.descriptions,
        };
        resolve(saveData);
      });
    },
    //编辑数据弹框
    showEditModal(dataItem) {
      this.curItem = dataItem; //接口数据格式
      this.videoList = dataItem.videos;
      this.imageList = dataItem.images;
      this.formData.groupName = dataItem.groupName;
      this.formData.titles = dataItem.titles;
      this.formData.descriptions = dataItem.descriptions;
    },
    confirmSelect: async function () {
      let saveData = await this.formatData();
      this.curItem.groupName = saveData.groupName;
      this.curItem.images = saveData.images;
      this.curItem.videos = saveData.videos;
      this.saveInStore();
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    saveCreativeGroup: async function () {
      if (this.formData.groupName === "") {
        this.$message({
          message: "请填写创意组名称",
          type: "warning",
        });
        return;
      }
      let saveData = await this.formatData();
      this.loading = true;
      saveAssetGroup({
        advertiserId: this.adCount,
        assetType: 2,
        data: JSON.stringify(saveData),
        groupName: this.formData.groupName,
        platType: 5,
      }).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.$message({
            message: "创意组保存成功",
            type: "success",
          });
          this.curItem.groupName = saveData.groupName;
          this.curItem.images = saveData.images;
          this.curItem.videos = saveData.videos;
          this.saveInStore();
        }
      });
    },
    saveInStore() {
      let copyData = JSON.parse(JSON.stringify(this.dataList));
      let storeData = copyData.map((item) => {
        return {
          itemId: item.itemId,
          groupName: item.groupName,
          images: item.images,
          videos: item.videos,
          titles: item.titles,
          descriptions: item.descriptions,
        };
      });
      this.$store.commit("set_creative_groups_google", storeData);
    },
    //检查并且保存最终数据（创意组数据已经实时同步到store，无需再次保存,只用检查必填项）
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          this.showNoDataTip = false;
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];
            const { flag: flagTitle } = this.validateTitles(item.titles);
            const { flag: flagDesc } = this.validateTitles(item.descriptions);
            if (
              item.groupName === "" ||
              (item.images.length === 0 && item.videos.length === 0) ||
              flagTitle.includes(true) ||
              flagDesc.includes(true)
            ) {
              pass = false;
              this.showEditModal(item);
              this.$nextTick(() => {
                this.$refs.modelRef.validate(() => {});
              });
              break;
            }
          }
          if (pass) {
            this.saveInStore();
            resolve();
          } else {
            reject();
          }
        } else {
          this.showNoDataTip = true;
          reject();
        }
      });
    },
    validateTitles(value) {
      let flag = [];
      let errorMsg = "";
      if (value.length < 2) {
        flag = [true];
        errorMsg = "标题不小于2个";
      }
      if (value.length > 5) {
        flag = [true];
        errorMsg = "标题不大于5个";
      }
      value.map((item, index) => {
        if (!item) {
          flag[index] = true;
          errorMsg = "标题不能为空";
        } else {
          if (Array.from(new Set(value)).length < value.length) {
            flag[index] = true;
            errorMsg = `标题不能重复`;
          } else {
            flag[index] = false;
          }
        }
      });
      return {
        flag,
        errorMsg,
      };
    },
    validateDesc(value) {
      let flag = [];
      let errorMsg = "";
      if (value.length < 1) {
        flag = [true];
        errorMsg = "描述不小于1个";
      }
      if (value.length > 5) {
        flag = [true];
        errorMsg = "描述不大于5个";
      }
      value.map((item, index) => {
        if (!item) {
          flag[index] = true;
          errorMsg = `描述不能为空`;
        } else {
          if (Array.from(new Set(value)).length < value.length) {
            flag[index] = true;
            errorMsg = `描述不能重复`;
          } else {
            flag[index] = false;
          }
        }
      });
      return {
        flag,
        errorMsg,
      };
    },
    //修改创意组实时更新到store
    changeGroupName(name) {
      this.$store.commit("set_creative_groupName_google", {
        id: this.curItem.itemId,
        name: name,
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGoogle.draftCampaign.advertiserId,
      creativeGroups: (state) => state.PromotionGoogle.creativeGroups,
    }),
  },
  watch: {
    creativeGroups(value) {
      if (value) {
        this.dataList = value.map((item) => {
          return {
            itemId: item.itemId,
            groupName: item.groupName,
            images: item.images,
            videos: item.videos,
            titles: item.titles,
            descriptions: item.descriptions,
          };
        });
        if (this.dataList.length > 0) {
          let curId = this.curItem.itemId;
          let curItem = this.dataList.find((item) => item.itemId === curId);
          if (curItem) {
            this.showEditModal(curItem);
          } else {
            this.showEditModal(this.dataList[this.dataList.length - 1]);
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.creative-group-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
    .nodata-tip {
      color: #f56c6c;
      font-size: 12px;
      position: relative;
      left: 10px;
      top: 1px;
    }
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }

  .modal-body {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 85px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 8px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .label-line {
          border-left: 1px solid rgba(0, 0, 0, 0.25);
          margin: 14px 12px;
          height: 12px;
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          .upload-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            /deep/ .el-form-item__content {
              line-height: 25px;
            }
            .add-btn {
              padding: 0px;
              margin: 0px;
            }
          }
          .upload-wrap {
            margin-top: 10px;
            border-radius: 2px;
            background: rgba(244, 244, 244, 1);
            padding: 8px 0px 16px 16px;
            .content-wrap {
              height: 300px;
              overflow: auto;
              display: flex;
              flex-wrap: wrap;
              &::-webkit-scrollbar {
                display: none;
                width: 0 !important;
                height: 0 !important;
                background: transparent;
              }
              &.video-wrap {
                .video-item {
                  padding: 9px 0px 9px 9px;
                  height: 176px;
                  border-radius: 4px;
                  border: 1px solid rgba(0, 0, 0, 0.11);
                  box-sizing: border-box;
                  background: rgba(255, 255, 255, 1);
                  display: flex;
                  position: relative;
                  margin: 8px 12px 0px 0px;

                  .video-slide {
                    width: 108px;
                    margin-right: 9px;
                    .video-header {
                      color: rgba(0, 0, 0, 0.65);
                      font-size: 14px;
                      padding: 4px 0;
                    }
                    .video-content {
                      display: inline-block;
                      width: 108px;
                      height: 130px;
                      background-color: #eee;
                      .material {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                      }
                    }
                  }
                  .close-btn {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: rgba(214, 214, 214, 1);
                    text-align: center;
                    line-height: 14px;
                    cursor: pointer;
                    font-size: 12px;
                  }
                }
              }
              &.image-wrap {
                .img-item {
                  height: 176px;
                  width: 240px;
                  padding: 9px;
                  border-radius: 4px;
                  border: 1px solid rgba(0, 0, 0, 0.11);
                  box-sizing: border-box;
                  background: rgba(255, 255, 255, 1);
                  position: relative;
                  margin: 8px 16px 8px 0px;
                  .img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .close-btn {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: rgba(214, 214, 214, 1);
                    text-align: center;
                    line-height: 14px;
                    cursor: pointer;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
    }
  }
  .select-count {
    height: 300px;
    font-size: 20px;
    color: #818181;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
